module.exports = __webpack_public_path__ + "img/stickers-acte-propriete.834c8194.jpg";